import React, { createElement } from 'react';
import { formatImage } from '@ifeng/public_method';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask';
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip';
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip';
import Chip from 'Chip';
import Style from './index.module.scss';

export interface GuestList_cjck_Props {
    chip: TYPE_Chip;
    style?: object;
}

const GuestList_cjck: React.FC<GuestList_cjck_Props> = (props) => {
    const { chip, style } = props;
    const chipData = useChip(chip) ?? [];
    const chipProps = formatChip(chip);

    return (
        <Chip {...chipProps}>
            <div className={Style.wrap} style={style}>
                <div className={Style.list}>
                    {Array.isArray(chipData) && chipData.length
                        ? chipData.slice(0, 4).map((item) => {
                              const { guestName, guestPic, guestTitle } = item;

                              return (
                                  <div className={Style.item}>
                                      <div className={Style.itemPic}>
                                          <img
                                              src={formatImage(guestPic, 278, 339) || guestPic}
                                              alt={guestName}
                                          />
                                      </div>
                                      <div className={Style.itemInfo}>
                                          <div className={Style.itemName}>{guestName}</div>
                                          <div className={Style.itemTitle}>{guestTitle}</div>
                                      </div>
                                  </div>
                              );
                          })
                        : null}
                </div>
                <Mask visible={!chip.id} zIndex={3}>
                    示例结构化碎片—{chip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default GuestList_cjck;
